import React, {Component, Fragment} from 'react';
import {autobind} from 'core-decorators';
import {reverse} from 'core/urls';
import {bagForm} from 'components/forms/decorators';
import createLLMultiplierBagsOrderMutation from 'graphql/mutations/orders/create-ll-multiplier-bags.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import ProductPicker from 'components/product-picker';
import {getDefaultAddress} from 'core/utils';
import AddressGrid from 'components/address-grid';
import {Form, Field, Textarea} from 'components/forms';
import Button from 'components/button';
import styles from '../styles.css';

@bagForm(createLLMultiplierBagsOrderMutation, 'll_multiplier_bags')
@autobind
export default class LLMultiplierBagsCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Lado a Lado Multiplicador' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='ll'
                        userType='multiplier'
                        links={['trialSigns']}
                    />
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'items', initial: []},
                                {key: 'notes', required: false},
                                {
                                    key: 'address',
                                    initial: getDefaultAddress(this.props.addressesData),
                                },
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid, values}) => (
                                <Fragment>
                                    <div className={styles.title}>Pedido de bolsas</div>
                                    <Field>
                                        <ProductPicker
                                            items={this.props.itemsData.bags}
                                            perItemLimit={this.props.itemsData.perItemLimit}
                                            toggleSelectedProduct={this.props.toggleSelectedProduct}
                                            {...getFieldProps('items')}
                                        />
                                        {renderErrors('items')}
                                    </Field>
                                    <Field label='Comentarios para Nidera'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                    <Field label='Dirección de envío de las bolsas'>
                                        <AddressGrid
                                            addresses={this.props.addressesData.addresses}
                                            returnUrl={reverse('llMultiplierBagsCreate')}
                                            returnData={values}
                                            {...getFieldProps('address')}
                                        />
                                        {renderErrors('address')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/lado-a-lado/multiplier/bags/create/index.js